function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 114,
  x: 0.5,
  y: 0.5,
  rx: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 24.5,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 92.5,
  r: 4
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M35.5 20.5v8m0 60v8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.5 44.5h6v6h-6zM32.5 59.5h6v8h-6zM32.5 50.5h6v9h-6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.617 48.5H40.5v21h-10v-21h2.052"
}));

function SvgRoomElectricitySwitchLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 115,
    viewBox: "0 0 71 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomElectricitySwitchLarge);
export default __webpack_public_path__ + "static/media/RoomElectricitySwitchLarge.581028aa.svg";
export { ForwardRef as ReactComponent };